import { LinkWithChevron } from '#components/Link/LinkWithChevron';
import type { SectionTitle } from '#domains/resolver/board-section-data';

import type { BoardData } from '../../../../pages/[[...board]]';

import styles from './BoardSectionTitle.module.scss';

type Props = {
	section: BoardData['sections'][number];
};

export function BoardSectionTitle({ section }: Props) {
	if (!sectionHasTitle(section)) {
		return null;
	}

	const isHighlight = section.schema === 'HIGHLIGHT_3';

	let content;

	if (!section.title.link) {
		content = <span className={styles.title}>{section.title.text}</span>;
	} else {
		content = (
			<LinkWithChevron className={styles.title} href={section.title.link}>
				{section.title.text}
			</LinkWithChevron>
		);
	}

	return (
		<header>
			<h3 className={`heading2 ${isHighlight ? styles.highlight : ''} ${styles.wrapper}`}>{content}</h3>
		</header>
	);
}

function sectionHasTitle(section: BoardData['sections'][number]): section is BoardData['sections'][number] & Required<SectionTitle> {
	// SUBJECTS_NEWS_WEATHER has an inline section title
	return 'title' in section && !!section.title?.text?.trim() && section.schema !== 'SUBJECTS_NEWS_WEATHER';
}
